import React from "react";
import { HiOutlineArrowSmLeft } from "react-icons/hi";
import { IoChevronBackOutline } from "react-icons/io5";

export default function WebBackBtn({clickfun}) {
    return (
        <div className="hidden lg:flex flex-col justify-center w-full h-full bg-white mt-[10px]" >
            <div className="w-full m-auto" >
                <div
                    className="mt-[10px] flex gap-1 items-center text-primary_v2 cursor-pointer"
                    onClick={()=>clickfun()}
                >
                    <IoChevronBackOutline className="text-xl" />
                    <p>Back to sign in </p>
                </div>
            </div>
        </div>
    )
}